import styles from "./style.module.scss";
import classNames from "classnames";
import { DatasetStatus } from "types";

interface DatasetStatusButtonProps {
  status: DatasetStatus;
  buttonStyle?: any;
}
export default function DatasetStatusButton({
  status,
  buttonStyle,
}: DatasetStatusButtonProps) {
  const getStyleByDatasetStatus: Record<DatasetStatus, string> = {
    [DatasetStatus.READY]: styles.greenButton,
    [DatasetStatus.DRAFT]: styles.greyButton,
    [DatasetStatus.INDEXING]: styles.blueButton,
    [DatasetStatus.READ_ONLY]: styles.blueButton,
    [DatasetStatus.PARTIAL_INDEX]: styles.orangeButton,
    [DatasetStatus.ERROR]: styles.failed,
  };

  const displaySpinnerByDatasetStatus: Record<DatasetStatus, boolean> = {
    [DatasetStatus.READY]: false,
    [DatasetStatus.DRAFT]: false,
    [DatasetStatus.INDEXING]: true,
    [DatasetStatus.READ_ONLY]: true,
    [DatasetStatus.PARTIAL_INDEX]: false,
    [DatasetStatus.ERROR]: false,
  };

  const inProgress = displaySpinnerByDatasetStatus[status];

  // Dynamic styling logic from deprecated version
  const handleButtonStyle = () => {
    const lineHeight = buttonStyle?.lineHeight
      ? parseFloat(buttonStyle.lineHeight)
      : null;

    if (!lineHeight) return buttonStyle;

    const paddingV = lineHeight * 0.5;
    const paddingH = lineHeight;

    return {
      ...buttonStyle,
      padding: `${paddingV}px ${paddingH}px`,
      borderRadius: `${paddingV}px`,
    };
  };

  const fontSize = handleButtonStyle()?.fontSize || undefined;
  const spinnerStyles = fontSize
    ? { height: fontSize, width: fontSize }
    : undefined;

  return (
    <div
      className={classNames(styles.default, getStyleByDatasetStatus[status])}
      style={handleButtonStyle()}
    >
      {inProgress && (
        <div className={styles.spinner} style={spinnerStyles}></div>
      )}
      {inProgress ? `${status}...` : status}
    </div>
  );
}
